/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */


(function($) {
    
    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function() {
                // JavaScript to be fired on all pages

                // Added the em.modal snippet from Bitbucket as it was missing from the source.. not the most elegant way but had to get it to work quickly
                em_modal = {};

                em_modal.options = {
                    hashTracking:false
                };

                em_modal.firstRun = true;

                //call any functions to be trigger on dom ready
                em_modal.init = function(){
                    em_modal.setup();
                    em_modal.closeCallback();
                };

                em_modal.setup = function(){
                    $('[data-remodal-id]').remodal( em_modal.options );

                    if (em_modal.firstRun) {

                        $(document).on('opened', '.remodal', function () {
                            // create the close button if it isn't there already
                            var $openModal = $('.remodal.remodal-is-opened');
                            if (!$openModal.find('.remodal-close').length) {
                                $openModal.append('<button data-remodal-action="close" class="remodal-close js-hidden"></button>');

                                // just to make the opening feel a little smoother:
                                setTimeout(function(){$openModal.find('.remodal-close').removeClass('js-hidden');},50);
                            }
                        });

                        em_modal.firstRun = false;
                    }
                };

                em_modal.closeCallback = function(){
                    $(document).on('closed', '.remodal', function (e) {
                        // modal was closed (the contents remain in the DOM)
                        // destroy video players etc here if needed

                        $(".modal-temp").remove();
                    });
                };

                em_modal.spawn = function( options ) {
                    var date = new Date();
                    var modal_id = 'modal-'+date.getTime();

                    var $modal = $('<div class="remodal modal-temp" data-remodal-id="'+modal_id+'"></div>');

                    if (typeof(options) == 'string') {
                        if (options.match(/^(https?:)?\//)) {
                            // options is a url
                            // regexp searches for protocol or slash in the beginning of the string

                            $modal.load(options, function( html ){
                                // options loaded
                                em_modal.show($modal);
                            });

                        } else if (options !== '') {
                            // assume options is a piece of markup

                            $modal.append(options);
                            em_modal.show($modal);

                        }
                    } else if (typeof(options)!='undefined') {

                        if (options instanceof jQuery) {
                            // options is a jQuery object

                            $modal.append(options);
                            em_modal.show($modal);

                        } else if (typeof(options)=='object') {
                            // options is a javascript object

                            if (options.padded) {
                                $modal.addClass('remodal--padded');
                            }

                            if (options.url) {
                                $modal.load(options.url, function( html ){
                                    // options loaded
                                    em_modal.show($modal);
                                });
                            } else if (options.content) {
                                $modal.append(options.content);
                                em_modal.show($modal);
                            }

                        }

                    }

                };

                em_modal.show = function( $modal ) {
                    var instance = $modal.remodal( em_modal.options );
                    instance.open();
                };

                em_modal.playVideo = function( videoId, videoType ) {
                    if (typeof(videoId)=='undefined') {
                        return false;
                    }
                    if (typeof(videoType)=='undefined') {
                        videoType = 'youtube';
                    }
                    videoId = videoId.replace(/[^A-Za-z0-9_-]/g,''); // clean the video id string
                    var remodalId = 'remodal-video-'+videoId;

                    var videoSrc = '';
                    if (videoType == 'vimeo') {
                        videoSrc = 'https://player.vimeo.com/video/'+videoId+'?autoplay=1';
                    } else {
                        videoSrc = 'https://www.youtube.com/embed/'+videoId+'?autoplay=1';
                    }
                    var $modal = $('<div class="remodal modal-temp" data-remodal-id="'+remodalId+'"><div class="remodal__video"><iframe width="560" height="315" src="'+videoSrc+'" frameborder="0" allowfullscreen></iframe></div></div>');
                    $modal.appendTo('body').remodal().open();
                };

                $(document).ready(function() {

                    /**
                     *
                     * ICT STANDARD DOWNLOAD PDF -PREQUISITE FORM
                     *
                     */

                    if (typeof(window.CorrectEmailaddress)!=='function') {
                        window.CorrectEmailaddress = function(SubscriberForm){
                         var pf_Email=SubscriberForm.pf_Email.value;
                         $(SubscriberForm.pf_Email).removeClass('input-error');

                         if (pf_Email.length > 255){
                          // alert("Kentän \"Sähköpostiosoite\" pituus voi olla maksimissaan 255 merkkiä.");
                          SubscriberForm.pf_Email.focus();
                          $(SubscriberForm.pf_Email).addClass('input-error');
                          return false;
                         }
                         if (SubscriberForm.pf_Email.value === ""){
                          // alert("Ole hyvä ja anna sähköpostiosoitteesi.");
                          SubscriberForm.pf_Email.focus();
                          $(SubscriberForm.pf_Email).addClass('input-error');
                          return false;
                         }
                         if (SubscriberForm.pf_Email.value.length < 6){
                          // alert("Ole hyvä ja syötä vähintään 7 merkkiä kenttään \"Sähköpostiosoite\".");
                          SubscriberForm.pf_Email.focus();
                          $(SubscriberForm.pf_Email).addClass('input-error');
                          return false;
                         }
                         var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,})$/;
                         if(reg.test(pf_Email) === false) {
                              // alert('Sähköpostiosoitteesi ei kelpaa. Ole hyvä yritä uudelleen.');
                              SubscriberForm.pf_Email.focus();
                              $(SubscriberForm.pf_Email).addClass('input-error');
                              return false;
                         }
                         var counter = 0;
                         for (i=1; i<=SubscriberForm.pf_CounterMailinglists.value; i++){
                          var checkBoxName = "pf_MailinglistName" + i;
                          if (document.getElementsByName(checkBoxName)[0].checked || document.getElementsByName(checkBoxName)[0].type === "hidden") {counter++;}
                         }
                         if (counter === 0){
                          // alert("Lomakkeeseen tulee liittää yksi tai useampi postituslista.");
                          // return false;
                         }
                         return true;
                        };
                    }

                    $(document).on('click','a[href="#itforbusiness-as-pdf"]',function(e){
                        e.preventDefault();
                        em_modal.spawn('/wp-content/themes/ict-standard-sage/api/pdf-form.php');
                    });

                    /**
                     * Fancy form inputs for PDF downloading -form
                     */
                    // trim polyfill : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim
                    if (!String.prototype.trim) {
                      (function() {
                        // Make sure we trim BOM and NBSP
                        var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
                        String.prototype.trim = function() {
                          return this.replace(rtrim, '');
                        };
                      })();
                    }

                    $(document).on('blur','input.input__field',function(ev){
                      if( ev.target.value.trim() === '' ) {
                        $(ev.target.parentNode).removeClass('input--filled');
                      }
                    });
                    $(document).on('focus','input.input__field',function(ev){
                      $(ev.target.parentNode).addClass('input--filled');
                    });



                    // first check if the form was just submitted
                    if (location.search) {
                      if (/formId=41415C4A774146594B7640/.test(location.search)) {
                        // this exact form was submitted and request was succesful
                        // so show thank you-message

                        var message = '<h3>Thank you for downloading IT Standard for Business.</h3>';
                        message += '<br><p><a class="btn btn--pdf" href="'+ pdf.book_url +'">Download IT for Business</a></p>';
                        message += '<p>Download link will also be sent once to the email address you provided.</p>';

                        em_modal.spawn('<div class="wysiwyg-html">'+message+'</div>');
                      }
                    }

                    /* /ICT STANDARD DOWNLOAD PDF -PREQUISITE FORM */



                    /* Add indicator to the Grid if its overflowing */
                    function setOverflowIndicators() {

                        // let's remove all the overflowing indicators before checking their new state
                        $('.is-overflowing').each(function() {
                            var el = $(this);
                            el.removeClass('is-overflowing');
                        });


                        $('.is-overflowing-table').each(function() {
                            var el = $(this);
                            el.removeClass('is-overflowing-table');
                        });

                        // let's set the overflow indicators
                        $('.row > div > .the-grid').each(function() {
                            var el = $(this);

                            // check if overflowing
                            if (el[0].scrollHeight > el[0].clientHeight || el[0].scrollWidth > el[0].clientWidth) {
                                el.addClass('is-overflowing');
                            }
                        });

                        // let's set the overflow indicators for grid overlay
                        $('.the-grid--overlay').each(function() {
                            var el = $(this);

                            // check if overflowing
                            if (el[0].scrollHeight > el[0].clientHeight || el[0].scrollWidth > el[0].clientWidth) {
                                el.addClass('is-overflowing');
                            }
                        });

                        /* Do the same for tables */
                        $('table:not(.grid-table)').each(function() {
                            var el = $(this);

                            // check if overflowing
                            if (el[0].scrollHeight > el[0].clientHeight || el[0].scrollWidth > el[0].clientWidth) {
                                el.parent('.table-container').addClass('is-overflowing-table');

                            }
                        });

                        // set event handlers to remove the indicators
                        $('.is-overflowing').on('scroll', function() {
                            var el = $(this);
                            el.removeClass('is-overflowing');
                        });

                        $('.is-overflowing-table table').on('scroll', function() {
                            var el = $(this);
                            el.parent().removeClass('is-overflowing-table');
                        });
                    }

                    // wrap all tables so we can add overflow indicator
                    function wrapTables() {
                        $('table:not(.grid-table)').each(function() {
                            var el = $(this);
                            el.wrap('<div class="table-container"></div>');
                        });
                    }

                    function addOverflowFix() {
                        $('table').each(function() {
                            var el = $(this);
                            el.parent().before('<div class="overflow-fix" />');
                        });
                    }

                    function positionGridOverlay() {
                        var el = $('.the-grid--overlay .the-grid');

                        el.removeClass('centered');

                        if ($(window).height() > el.height()) {
                            el.addClass('centered');
                        }
                    }

                    /* Close navbar on resize */
                    function toggleSidebar() {
                        if ($('.sidebar').length) {
                            $('body').toggleClass('sidebar-open');
                        }
                    }

                    function toggleImageOverlay() {
                        $('body').toggleClass('image-open');

                        $('.image-wrapper > img').remove();
                    }

                    //a function to equalize hieghts of elements within a parent
                    function equalizeHeight(){

                        // if($(window).width() < 768){
                        //     return false;
                        // }

                        $(".equalizeHeight").each(function(){
                            var el = $(this);
                            var largestHeight = 0;
                            var divs;

                            if(el.data("equalize")){
                                divs = el.find("."+el.data("equalize"));
                            }
                            else {
                                divs = el.find("> div");
                            }

                            //get the biggest height
                            divs.each(function(){
                                var height = $(this).outerHeight();
                                if(height > largestHeight){
                                    largestHeight = height;
                                }
                            });

                            //set the biggest hieght to all
                            divs.each(function(){
                                $(this).css({height: largestHeight});
                            });
                        });

                    }




                    //lets set up the hero slick sliders and center the hero text
                    function setupHeros(){
                        $(".hero").each(function(){

                            var el = $(this);
                            var slides = el.find(".hero__slide");
                            var parentHeight = slides.eq(0).height();

                            slides.each(function(){
                                var slide = $(this);
                                var height = slide.find(".container-fluid").height();

                                var margin = (parentHeight - height) / 2;

                                slide.find(".container-fluid").css({"margin-top": margin});
                            });
                        });

                        $(".hero--slick").slick({
                            dots: true,
                            arrows: false,
                            autoplay: true,
                            autoplaySpeed: 4000,
                        });

                        $(".hero").addClass("hero--show");
                    }




                    //category accordion for home toc
                    function setupHomeToc() {

                        var el = $(".home__toc");
                        var ul = el.find("ul");
                        var children = ul.find(".children");
                        var tabArea = el.find(".home__toc__tcontent");

                        //loop all children and copy into tabbed area
                        children.each(function( index ) {
                            var el = $(this);
                            var childrenClass = el.closest("li").attr('class').split(' ')[0];

                            var clone = el.clone();
                            var div = $("<div>", {class: childrenClass}).html(clone);

                            div.appendTo(tabArea);
                        });

                        // when clicking children items we should prevent event propagation to make these links work
                        $('.home__toc__list ul > li.has-children li').on('click', function(e) {
                            e.stopPropagation();
                        });

                        //now we need the event handlers for this
                        var tocParents = $('.home__toc__list ul > li.has-children');
                        tocParents.on('click', function(e) {
                            e.preventDefault();
                            var el = $(this);

                            var childrenClass = el.attr('class').split(' ')[0];

                            if(!el.hasClass('js-show-children')) {
                                $(".home__toc__tcontent > div").removeClass("js-show");
                                $(".home__toc__tcontent ." + childrenClass).addClass("js-show");
                                tocParents.removeClass("js-show-children");
                                el.addClass("js-show-children");

                                if ($(window).width() >= 768) {
                                    el.siblings().children('.children').hide();
                                    el.children('.children').show();
                                } else {
                                    el.siblings().children('.children').slideUp(350);
                                    el.children('.children').stop(true).slideToggle(350);
                                }
                            }

                        });

                        //lets show the first child
                        if ($(window).width() >= 768) {
                            tocParents.eq(0).click();
                        }
                    }



                    $('.nav-overlay').on('click', function() {
                        toggleSidebar();
                    });

                    /* TEMP: Toggle right sidebar */
                    $('.js-side-nav').on('click', function(e) {

                        if (e.preventDefault) {
                            e.preventDefault();
                        } else {
                            e.returnValue = false;
                        }

                        toggleSidebar();
                    });

                  /* click handler for download pdf button in footer */
                  $('.js-download-pdf').on('click', function(e) {
                    e.preventDefault();
                  });

                  /* New download handler */
                  if ($('.js-download-url').length) {
                    var dlUrl = $('.js-download-url').data('download-url');
                    setTimeout(function () {
                      window.location = dlUrl;
                    }, 2000); // download the file in 5 seconds
                  }

                    /* Toggle Social Media overlay */
                    function toggleSocialShare() {
                        $('body').toggleClass('social-share-open');
                        var el = $('.js-share');

                        el.find('i').toggleClass('fa-share-alt');
                        el.find('i').toggleClass('fa-close');
                    }

                    $('.js-share').on('click', function(e) {
                        e.preventDefault();
                        toggleSocialShare();
                    });

                    $('.js-share-close').on('click', function(e) {
                        e.preventDefault();
                        toggleSocialShare();
                    });




                    //lets toggle ze grid overlay
                    function toggleGridOverlay() {
                        $('body').toggleClass('grid-overlay-open');
                        var el = $('.js-grid');

                        el.find('i').toggleClass('icon-icon-the-grid');
                        el.find('i').toggleClass('fa-close');
                    }

                    $('.js-grid').on('click', function(e) {
                        e.preventDefault();
                        toggleGridOverlay();
                    });

                    $('.js-grid-close').on('click', function(e) {
                        e.preventDefault();
                        toggleGridOverlay();
                    });




                    /* Toggle when clicking overlay */
                    $('.sidebar-open .nav-overlay').on('click', function() {
                        toggleSidebar();
                    });

                    /* Toggle sidebar on tablet from peeking overlay */
                    $('.js-sidebar-overlay').on('click', function() {
                        toggleSidebar();
                    });

                    $('.js-sidebar-close').on('click', function() {
                        toggleSidebar();
                    });




                    /* Sidebar Nav Child Animations */

                    $('.sidebar__toc > ul > li > a').on('click', function() {
                        if ($(this).children('.children')) {
                            $(this).siblings('.children').stop(true).slideToggle(350);
                        }
                    });



                    /* Equalize heights for article nav elements in footer */

                    function equalizeHeightsArticleNav() {

                        // reset the height
                        $('.article-nav').height('auto');

                        // calculate new heights
                        if ($(window).width() < 768) {

                           return false;

                        } else {

                            var maxHeight = 0;

                            $('.article-nav').each(function(){
                                var el = $(this);
                                if ($(this).height() > maxHeight) {
                                    maxHeight = $(this).height();
                                }
                            });

                            $('.article-nav').height(maxHeight);
                        }
                    }



                    /* ACCORDION */

                    // Vars for clarity
                    var title = $('.js-accordion__title'),
                        content = $('.js-accordion__content'),
                        accordion = $('.js-accordion');

                    // Click event handler. Slide contents.
                    title.click(function() {

                        var el = $(this);

                        // Slide toggle on the clicked item
                        el.next(content).stop(true).slideToggle(350);

                        // Mark opened element as active
                        el.toggleClass("is-active");

                        // Slide other opened accordion item up
                        if (accordion.attr("data-multiopen") === 'true') {
                            el.parent().siblings().children().removeClass("is-active");
                            el.parent().siblings().children().next().slideUp(350);
                        }
                    });



                    /* SOCIAL MEDIA SHARING */

                    // Using windowPopup approach from @link https://jonsuh.com/blog/social-share-links/
                    function windowPopup(url, width, height) {
                      // Calculate the position of the popup so
                      // it's centered on the screen.
                      var left = (screen.width / 2) - (width / 2),
                          top = (screen.height / 2) - (height / 2);

                      window.open(
                        url,
                        "",
                        "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left
                      );
                    }

                    function setSocialMediaLinks() {

                        var socialMediaLinks = $('.js-social-links');
                        var currentEncodedURL = encodeURIComponent(window.location.href);

                        // set the share urls
                        socialMediaLinks.each(function() {
                            var el = $(this);
                            var shareURL = el.data('share-url') + currentEncodedURL;

                            el.attr('href', shareURL);
                        });

                        if (!Modernizr.touch) {
                            $(".js-social-links").on("click", function(e) {
                                e.preventDefault();

                                windowPopup($(this).attr("href"), 500, 300);
                            });
                        }
                    }


                    /**
                    * Twitterfeed block masonry grid]
                    */
                    var $container = $('ul.twitterfeed');

                    // initialize Masonry after all images have loaded
                    $container.imagesLoaded( function() {
                        if($(window).width() > 569){
                            $container.masonry({
                                itemSelector: 'li'
                            });
                        }
                    });


                    /* These are executed on window.resize with throttle! */
                    function onResizeEvent() {
                        setOverflowIndicators();
                        equalizeHeightsArticleNav();
                        positionGridOverlay();
                    }


                  /**
                   * Scroll effects to be applied when the user scrolls. This is mainly used
                   * to handle the logo reveal for the navbar when the user scrolls past the
                   * site header where the logo is visible.
                   * @return {[type]} [description]
                   */
                  function scrollEffects() {
                    if ($(window).width() < 1200) {
                      var height = $('.js-mobile-header').outerHeight();
                      var extra = 10;
                      if($(window).scrollTop() > (height + extra)){
                        $('.js-mobile-header').addClass('is-scrolled');
                        // console.log('a');
                      } else {
                        $('.js-mobile-header').removeClass('is-scrolled');
                        // console.log('b');
                      }
                    }

                    if ($('.js-mobile-header').length) {
                        var didScroll,
                            lastScrollTop = 0,
                            delta = 50,
                            navbarHeight = $('.js-mobile-header').outerHeight();

                        $(window).scroll(function(event){
                            didScroll = true;
                        });

                        setInterval(function() {
                            if (didScroll) {
                                var st = $(window).scrollTop();

                                // Make sure they scroll more than delta
                                if(Math.abs(lastScrollTop - st) <= delta) {
                                    return;
                                }

                                // If they scrolled down and are past the navbar, add class .nav-up.
                                // This is necessary so you never see what is "behind" the navbar.
                                if (st > lastScrollTop && st > navbarHeight){
                                    // Scroll Down
                                    $('.js-mobile-header').removeClass('nav-down').addClass('nav-up');
                                } else {
                                    // Scroll Up
                                    if(st + $(window).height() < $(document).height()) {
                                        $('.js-mobile-header').removeClass('nav-up').addClass('nav-down');
                                    }
                                }

                                lastScrollTop = st;
                                didScroll = false;
                            }
                        }, 250);
                    }



                };

                    //some functions to call upon DOM ready
                    setupHomeToc();
                    equalizeHeight();
                    setupHeros();
                    wrapTables();
                    addOverflowFix();
                    equalizeHeightsArticleNav();
                    setOverflowIndicators();
                    setSocialMediaLinks();
                    positionGridOverlay();
                    scrollEffects();


                    // initialize hyphenator for finnish grid
                    $('.ict-lang-fi .grid-table').finnishHyphenator();

                    //function calls to trigger upon window resize if needed (throttled to 175ms)
                    $(window).resize( _.throttle(onResizeEvent, 175) );



                });
            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function() {
                // JavaScript to be fired on the home page
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function() {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

    var imageLink = $('.epage-template-default .single__content img').parent('a');
    if(imageLink.length > 0){
        imageLink.attr('data-lightbox','wp-image');
    }

})(jQuery); // Fully reference jQuery after this point.

function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
}

// The two placeholder messages, kept in one place because both the load
// handler and the consent-change handler can show them.
var pardotNoticeNoConsent = '<div class="pardotform-cookie-notice"><p><i class="fa fa-exclamation-triangle"></i> Make sure you have accepted the website cookies, to show the form correctly</p><p><a href="#" class="c-btn c-btn--white-alt" onclick="event.preventDefault();openCookieSettings();">Cookies Settings</a></p></div>';
var pardotNoticeBrowserBlocked = '<div class="pardotform-cookie-notice"><p><i class="fa fa-exclamation-triangle"></i> This form is blocked by your browser privacy settings.  To show the form correctly, you need to turn cookies on and reload the page.</p></div>';

/**
 * Put a placeholder where a form would have been.
 *
 * Inserted *after* the paragraph holding the iframe rather than appended
 * inside it: wpautop wraps the shortcode output in a <p>, and a <div> is not
 * valid inside a <p>. The previous code appended straight into the parent and
 * disagreed with itself about whether that parent was a <p> or a <div>, so it
 * silently did nothing whenever it guessed wrong.
 *
 * Any notice already attached to this form is removed first, so repeated
 * consent changes cannot stack up duplicates.
 */
function showPardotNotice($iframe, html){
    var $anchor = $iframe.closest('p');

    if(!$anchor.length){
        $anchor = $iframe;
    }

    $anchor.nextAll('.pardotform-cookie-notice').first().remove();
    $anchor.after(html);

    // A blocked iframe has no src, so it can never paint anything. Hiding it
    // keeps it from leaving a gap above the placeholder.
    $iframe.hide();
}

function hidePardotNotice(){
    if(!isPardotConsentGiven()){
        return;
    }

    // Consent has just been given, so clear the placeholders and let the
    // iframes -- whose src Cookiebot has now restored -- paint again.
    $('.pardotform-cookie-notice').remove();
    $('.pardotform').css('display', '');

    setTimeout(function(){
        $('.pardotform').each(function() {
            try {
                if($(this).contents().find('body').is(':empty') ){
                    showPardotNotice($(this), pardotNoticeBrowserBlocked);
                }
            } catch (error) {
                // Cross-origin iframe once it has loaded: nothing to inspect,
                // which means the form is working.
            }
        });
    }, 1200);
}

/**
 * Has the visitor consented to the category Pardot forms fall under?
 *
 * Pardot is marketing automation, so it maps to Cookiebot's "marketing"
 * category -- the equivalent of the OneTrust group C0004 this used to read.
 *
 * Reads the live API when Cookiebot has loaded, and falls back to parsing the
 * CookieConsent cookie when it has not (the plugin loads its script async, so
 * on a cold load this can run first).
 */
function isPardotConsentGiven(){
    if (window.Cookiebot && window.Cookiebot.consent) {
        return !!window.Cookiebot.consent.marketing;
    }

    var raw = decodeURIComponent(getCookie("CookieConsent") || '');

    return /marketing\s*:\s*true/.test(raw);
}

/**
 * Re-check the Pardot notice whenever consent changes.
 *
 * Cookiebot fires these on window, which replaces the previous approach of
 * finding OneTrust's individual accept/save buttons by id and class and
 * attaching click handlers to each -- that broke whenever the banner markup
 * changed, and missed consent given any other way.
 *
 * CookiebotOnConsentReady also covers the returning visitor whose choice is
 * already stored, so no banner is ever shown.
 */
['CookiebotOnAccept', 'CookiebotOnDecline', 'CookiebotOnConsentReady'].forEach(function(evt){
    window.addEventListener(evt, function(){
        hidePardotNotice();
    });
});

/**
 * Open the consent dialog again. Used by the "Cookies Settings" link in the
 * placeholder shown where a blocked form would be.
 */
function openCookieSettings(){
    if (window.Cookiebot && typeof window.Cookiebot.renew === 'function') {
        window.Cookiebot.renew();
    }
}

$(window).on('load', function(){

    if($('.pardotform').length > 0){

        var pardotGroupAccepted = isPardotConsentGiven();
        
        $('.pardotform').each(function() {
            try {
                if(!$(this).contents().find('body').is(':empty')){
                    return;
                }

                showPardotNotice(
                    $(this),
                    pardotGroupAccepted ? pardotNoticeBrowserBlocked : pardotNoticeNoConsent
                );
            } catch (error) {
                // Cross-origin iframe once it has loaded: nothing to inspect,
                // which means the form is working.
            }
        });
    }
});

var em = {};
jQuery(function(){
    
    for(var key in em) {
       
        if (typeof(em[key].init) === "function") {
            em[key].init();
        } else {
            console.error("Your block " + key + " doesn't define init-method.");
        }
    }
});
